export const SET_CREATION_STEP = "SET_CREATION_STEP";
export const SET_EDIT_CREATION_STEP = "SET_EDIT_CREATION_STEP";
export const CLEAR_CREATION = "CLEAR_CREATION";

export const POST_EVENT = "POST_EVENT";
export const UPDATE_EVENT = "UPDATE_EVENT";
export const GET_EDIT_EVENT = "GET_EDIT_EVENT";